import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Displays a value or a fallback if the value is null, undefined, or an empty string.
 *
 * @param value - The value to be displayed.
 * @param fallback - The fallback string to be displayed if the value is null, undefined, or an empty string. Defaults to '-'.
 * @returns The value if it is not null, undefined, or an empty string; otherwise, the fallback string.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayValue = (value: any, fallback: string = '-') => {
  return value === null || value === undefined || value === ''
    ? fallback
    : value;
};
